import React, { useEffect} from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { BiRightArrow } from 'react-icons/bi';
import { TbTrain } from 'react-icons/tb';
import { MdLocationPin } from 'react-icons/md';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { BsFillRecordCircleFill } from 'react-icons/bs';
import { GiTicket } from 'react-icons/gi';

import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import "../assets/styles/UIComponents.css"
import { format } from 'date-fns'
import { isFuture } from 'date-fns'
import { parse } from 'date-fns'
import { isEqual } from 'date-fns'



const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<BiRightArrow sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function OurJourney() {

  const [name, setName] = React.useState('');
  const [expanded, setExpanded] = React.useState('panel1');
  const [tableData] = React.useState(
    [{"passenger" : "M & S Maharana","source" : "Brahmapur(BAM)","destination" : "Bhubaneswar(BBS)","dod" : "03-DEC-2022","tod" : "07:25 PM","doa" : "03-DEC-2022","toa" : "10:05 PM","seatDetails" : "CNF/S7/MB(26 & 29)","pnr" : "6210408780","train" : "18118/Rajyarani Express"}, {"passenger" : "M & S Maharana","source" : "Bhubaneswar(BBS)","destination" : "Ujjain(UJN)","dod" : "04-DEC-2022","tod" : "01:50 AM","doa" : "05-DEC-2022","toa" : "03:10 AM","seatDetails" : "CNF/B3/MB(42 & 45)","pnr" : "6109944778","train" : "22910/Puri BL SF"}, {"passenger" : "M & S Maharana","source" : "Indore Jn. BG(INDB)","destination" : "Ahmedabad Jn.(ADI)","dod" : "06-DEC-2022","tod" : "11:00 PM","doa" : "07-DEC-2022","toa" : "08:25 AM","seatDetails" : "CNF/B2/LB(49 & 52)","pnr" : "8837946491","train" : "19310/Shanti Express"}, {"passenger" : "M & S Maharana","source" : "Ahmedabad Jn.(ADI)","destination" : "Veraval(VRL)","dod" : "09-DEC-2022","tod" : "10:10 PM","doa" : "10-DEC-2022","toa" : "06:00 AM","seatDetails" : "CNF/B2/LB(57 & 60)","pnr" : "8357903404","train" : "22957/Somnath Express"}, {"passenger" : "M & S Maharana","source" : "Veraval(VRL)","destination" : "Dwarka(DWK)","dod" : "10-DEC-2022","tod" : "11:05 PM","doa" : "11-DEC-2022","toa" : "07:03 AM","seatDetails" : "CNF/B2/LB(65 & 68)","pnr" : "8257904301","train" : "19251/SMNH Okha Express"}, {"passenger" : "M & S Maharana","source" : "Dwarka(DWK)","destination" : "Mumbai Central(MMCT)","dod" : "13-DEC-2022","tod" : "11:41 AM","doa" : "14-DEC-2022","toa" : "04:55 AM","seatDetails" : "CNF/B2/LB(65 & 68)","pnr" : "8457905307","train" : "22946/Saurashtra Mail"}, {"passenger" : "M & S Maharana","source" : "Dadar(DR)","destination" : "Sainagar Shirdi(SNSI)","dod" : "14-DEC-2022","tod" : "09:45 PM","doa" : "15-DEC-2022","toa" : "03:45 AM","seatDetails" : "CNF/B2/LB(49 & 52)","pnr" : "8657970351","train" : "12131/Dadar Sainagar Express"}, {"passenger" : "M & S Maharana","source" : "Chatrapati Sivaji Maharaj Terminal(CSMT)","destination" : "Brahmapur(BAM)","dod" : "19-DEC-2022","tod" : "02:00 PM","doa" : "20-DEC-2022","toa" : "08:20 PM","seatDetails" : "CNF/B2/LB(57 & 60)","pnr" : "8557971441","train" : "11019/Konark Express"}, {"passenger" : "B & S Maharana","source" : "Brahmapur(BAM)","destination" : "Bhubaneswar(BBS)","dod" : "03-DEC-2022","tod" : "07:25 PM","doa" : "03-DEC-2022","toa" : "10:05 PM","seatDetails" : "CNF/S7/LB(25 & 28)","pnr" : "6210408780","train" : "18118/Rajyarani Express"}, {"passenger" : "B & S Maharana","source" : "Bhubaneswar(BBS)","destination" : "Ujjain(UJN)","dod" : "04-DEC-2022","tod" : "01:50 AM","doa" : "05-DEC-2022","toa" : "03:10 AM","seatDetails" : "CNF/B3/LB(36) & MB(37)","pnr" : "6109944370","train" : "22910/Puri BL SF"}, {"passenger" : "B & S Maharana","source" : "Indore Jn. BG(INDB)","destination" : "Ahmedabad Jn.(ADI)","dod" : "06-DEC-2022","tod" : "11:00 PM","doa" : "07-DEC-2022","toa" : "08:25 AM","seatDetails" : "CNF/B1/LB(57 & 60)","pnr" : "8457886773","train" : "19310/Shanti Express"}, {"passenger" : "B & S Maharana","source" : "Ahmedabad Jn.(ADI)","destination" : "Veraval(VRL)","dod" : "09-DEC-2022","tod" : "10:10 PM","doa" : "10-DEC-2022","toa" : "06:00 AM","seatDetails" : "CNF/B2/LB(49 & 52)","pnr" : "8557903034","train" : "22957/Somnath Express"}, {"passenger" : "B & S Maharana","source" : "Veraval(VRL)","destination" : "Dwarka(DWK)","dod" : "10-DEC-2022","tod" : "11:05 PM","doa" : "11-DEC-2022","toa" : "07:03 AM","seatDetails" : "CNF/B2/LB(57 & 60)","pnr" : "8837968203","train" : "19251/SMNH Okha Express"}, {"passenger" : "B & S Maharana","source" : "Dwarka(DWK)","destination" : "Mumbai Central(MMCT)","dod" : "13-DEC-2022","tod" : "11:41 AM","doa" : "14-DEC-2022","toa" : "04:55 AM","seatDetails" : "CNF/B2/LB(57 & 60)","pnr" : "8357905074","train" : "22946/Saurashtra Mail"}, {"passenger" : "B & S Maharana","source" : "Dadar(DR)","destination" : "Sainagar Shirdi(SNSI)","dod" : "14-DEC-2022","tod" : "09:45 PM","doa" : "15-DEC-2022","toa" : "03:45 AM","seatDetails" : "CNF/B1/LB(57 & 60)","pnr" : "8357970380","train" : "12131/Dadar Sainagar Express"}, {"passenger" : "B & S Maharana","source" : "Chatrapati Sivaji Maharaj Terminal(CSMT)","destination" : "Brahmapur(BAM)","dod" : "19-DEC-2022","tod" : "02:00 PM","doa" : "20-DEC-2022","toa" : "08:20 PM","seatDetails" : "CNF/B1/LB(65 & 68)","pnr" : "8457971655","train" : "11019/Konark Express"}, {"passenger" : "A & B Maharana","source" : "Brahmapur(BAM)","destination" : "Bhubaneswar(BBS)","dod" : "03-DEC-2022","tod" : "07:25 PM","doa" : "03-DEC-2022","toa" : "10:05 PM","seatDetails" : "CNF/S7/UB(27 & 30)","pnr" : "6210408780","train" : "18118/Rajyarani Express"}, {"passenger" : "A & B Maharana","source" : "Bhubaneswar(BBS)","destination" : "Ujjain(UJN)","dod" : "04-DEC-2022","tod" : "01:50 AM","doa" : "05-DEC-2022","toa" : "03:10 AM","seatDetails" : "CNF/B1/MB(58 & 61)","pnr" : "6409945061","train" : "22910/Puri BL SF"}, {"passenger" : "A & B Maharana","source" : "Indore Jn. BG(INDB)","destination" : "Ahmedabad Jn.(ADI)","dod" : "06-DEC-2022","tod" : "11:00 PM","doa" : "07-DEC-2022","toa" : "08:25 AM","seatDetails" : "CNF/B4/LB(49 & 52)","pnr" : "8757887015","train" : "19310/Shanti Express"}, {"passenger" : "A & B Maharana","source" : "Ahmedabad Jn.(ADI)","destination" : "Veraval(VRL)","dod" : "09-DEC-2022","tod" : "10:10 PM","doa" : "10-DEC-2022","toa" : "06:00 AM","seatDetails" : "CNF/B3/LB(49 & 52)","pnr" : "8357903360","train" : "22957/Somnath Express"}, {"passenger" : "A & B Maharana","source" : "Veraval(VRL)","destination" : "Dwarka(DWK)","dod" : "10-DEC-2022","tod" : "11:05 PM","doa" : "11-DEC-2022","toa" : "07:03 AM","seatDetails" : "CNF/B3/LB(57 & 60)","pnr" : "8457903962","train" : "19251/SMNH Okha Express"}, {"passenger" : "A & B Maharana","source" : "Dwarka(DWK)","destination" : "Mumbai Central(MMCT)","dod" : "13-DEC-2022","tod" : "11:41 AM","doa" : "14-DEC-2022","toa" : "04:55 AM","seatDetails" : "CNF/B3/LB(57 & 60)","pnr" : "8837969778","train" : "22946/Saurashtra Mail"}, {"passenger" : "A & B Maharana","source" : "Dadar(DR)","destination" : "Sainagar Shirdi(SNSI)","dod" : "14-DEC-2022","tod" : "09:45 PM","doa" : "15-DEC-2022","toa" : "03:45 AM","seatDetails" : "CNF/B2/LB(57 & 60)","pnr" : "8838051055","train" : "12131/Dadar Sainagar Express"}, {"passenger" : "A & B Maharana","source" : "Chatrapati Sivaji Maharaj Terminal(CSMT)","destination" : "Brahmapur(BAM)","dod" : "19-DEC-2022","tod" : "02:00 PM","doa" : "20-DEC-2022","toa" : "08:20 PM","seatDetails" : "CNF/B2/LB(65 & 68)","pnr" : "8557971996","train" : "11019/Konark Express"}]
  );

  const handleChange = (event) => {
    setName(event.target.value);
  };


  const handleAccordionChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    tableDetails();
  });

  function tableDetails(){
    var tempTableData = []
    var todaysDate = format(new Date(), 'dd-MMM-yyyy').toUpperCase()
    // var currentTime = format(new Date(), 'hh:mm aa').toUpperCase()

    console.log(isFuture(parse("06-DEC-2022", 'dd-MMM-yyyy', new Date())))
    console.log(isEqual(parse("06-DEC-2022", 'dd-MMM-yyyy', new Date()), parse("05-DEC-2022", 'dd-MMM-yyyy', new Date())))


    for(var i=0; i<tableData.length; i++){
      var unitData = {}
      if(name === tableData[i].passenger){
        unitData.passenger = tableData[i].passenger
        unitData.source = tableData[i].source
        unitData.dod = tableData[i].dod
        unitData.tod = tableData[i].tod
        unitData.destination = tableData[i].destination
        unitData.doa = tableData[i].doa
        unitData.toa = tableData[i].toa
        unitData.seatDetails = tableData[i].seatDetails
        unitData.pnr = tableData[i].pnr
        unitData.train = tableData[i].train
        tempTableData.push(unitData)
      }
    }
    const listItems = tempTableData.map((paxDetails, index) =>
      <Accordion key={"accord_"+index} expanded={expanded === 'panel'+index+1} onChange={handleAccordionChange('panel'+index+1)}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <span style={{fontFamily:"Exo2-Bold", fontSize:"18px", width:"70%"}}>
            <span style={{fontWeight:"bold", color: isEqual(parse(paxDetails.dod, 'dd-MMM-yyyy', new Date()), parse(todaysDate, 'dd-MMM-yyyy', new Date())) ? "#ebab44" : "black"}}>{paxDetails.dod}</span> <br/>
            {paxDetails.source} <TbTrain sx={{ fontSize: '0.9rem' }} style={{position:"relative", top:"2px"}} /> {paxDetails.destination} <br/>
            <span style={{fontSize:"14px", fontWeight:"bold", color:"rgb(159, 155, 155)"}}>{paxDetails.train}</span>
          </span>
          <span style={{position:"absolute", right:"20px", top:"33%"}}>
            {isEqual(parse(paxDetails.dod, 'dd-MMM-yyyy', new Date()), parse(todaysDate, 'dd-MMM-yyyy', new Date())) ? 
              <BsFillRecordCircleFill style={{position:"relative", fontSize:"30px", color:"#ebab44"}} />
            :
              !isFuture(parse(paxDetails.dod, 'dd-MMM-yyyy', new Date())) ?
                <BsFillCheckCircleFill style={{position:"relative", fontSize:"30px", color:"#4bbd4b"}} />
              :
                <GiTicket style={{position:"relative", fontSize:"30px", color:"rgb(159, 155, 155)"}} />
              
            }
            
          </span>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{position:"relative"}}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="trainCards" style={{display: "flex", justifyContent: "center", fontWeight:"bold", background:"#edf0da"}}>
                    PNR : {paxDetails.pnr}
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <div className="trainCards" style={{display: "flex", justifyContent: "center", fontWeight:"bold", background:"#d5ebc3"}}>
                <MdLocationPin sx={{ fontSize: '0.9rem' }} style={{position:"relative", top:"3px", marginRight:"5px", color:"#439c2d"}}/> Source
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className="trainCards" style={{display: "flex", justifyContent: "center", fontWeight:"bold", background:"#f2d0d1"}}>
                <MdLocationPin sx={{ fontSize: '0.9rem' }} style={{position:"relative", top:"3px", marginRight:"5px", color:"#9c2d2f"}}/> Destination
              </div>
            </Grid>
            <Grid item xs={6} style={{position:"relative"}}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="trainCards">
                    <div>{paxDetails.source}</div>
                    <div>{paxDetails.dod}</div>
                    <div>{paxDetails.tod}</div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{position:"relative"}}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                  <div className="trainCards">
                    <div>{paxDetails.destination}</div>
                    <div>{paxDetails.doa}</div>
                    <div>{paxDetails.toa}</div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{position:"relative"}}>
              <div className="trainCards">
                <b>Seat Details : </b>{paxDetails.seatDetails}
              </div>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
    return (
      <>{listItems}</>
    ); 
  }

  return (
    <Grid container spacing={2} style={{padding:"10px"}}>
      <Grid item xs={12} style={{position:"relative"}}>
        <h1><TbTrain sx={{ fontSize: '0.9rem' }} style={{position:"relative", top:"5px", marginRight:"5px"}} />Travel Details</h1>
        <Box sx={{ minWidth: 120 }}>
          <FormControl variant="standard" style={{width:"100%"}}>
            <InputLabel id="demo-simple-select-standard-label">Select Passenger</InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={name}
              label="Age"
              onChange={handleChange}
            >
              <MenuItem value={"M & S Maharana"}>M & S Maharana</MenuItem>
              <MenuItem value={"B & S Maharana"}>B & S Maharana</MenuItem>
              <MenuItem value={"A & B Maharana"}>A & B Maharana</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <br/>
        {tableDetails()}
      </Grid>
    </Grid>
  );
}

export default OurJourney;